import { render, staticRenderFns } from "./ColorDemo.vue?vue&type=template&id=f9d99848&scoped=true&"
import script from "./ColorDemo.vue?vue&type=script&lang=js&"
export * from "./ColorDemo.vue?vue&type=script&lang=js&"
import style0 from "./ColorDemo.vue?vue&type=style&index=0&id=f9d99848&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d99848",
  null
  
)

export default component.exports